<template>
  <div class='pie-donut-chart'>
    <Tooltip
      :show="showTooltip"
      v-bind="tooltipContent"
      :position="tooltipPosition"
      :chartWidth="chartWidth"
    />
    <ChartWrapper
      :data="data"
      :height="height"
      :width="chartWidth"
      :radius="radius"
      :pieChart="true"
    >
      <template #pie-chart="props">
        <PieChart
          v-bind="props"
          :isDonut="isDonut"
          :hasLabels="hasLabels"
          :hasOuterLabels="hasOuterLabels"
          :hasTooltip="hasTooltip"
          :strokeWidth="strokeWidth"
          :paddingAngle="paddingAngle"
          :transitionSpeed="transitionSpeed"
          :wrapperWidth="wrapperWidth"
          :wrapperHeight="height"
          @onHover="setTooltip"
          @onLeave="hideTooltip"
        >
        </PieChart>
      </template>
    </ChartWrapper>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { timeFormat } from 'd3-time-format';
import {
  getValueAndLabel,
} from '../../../../../../services/dashboard/displayFormatService';
import Tooltip from '../../../Tooltips/ChartTooltip/Tooltip.vue';
import ChartWrapper from '../Graph/ChartWrapper.vue';
import PieChart from '../Graph/PieChart.vue';

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    isDonut: {
      type: Boolean,
      default: true,
    },
    hasLabels: {
      type: Boolean,
      default: false,
    },
    hasOuterLabels: {
      type: Boolean,
      default: false,
    },
    hasTooltip: {
      type: Boolean,
      default: false,
    },
    transitionSpeed: {
      type: Number,
      default: 1000,
    },
    strokeWidth: {
      type: Number,
      default: 44,
    },
    chartWidth: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 278,
    },
    wrapperWidth: {
      type: Number,
      default: 400,
    },
    radius: {
      type: Number,
      default: 114,
    },
    paddingAngle: {
      type: Number,
      default: 0.03,
    },
  },
  data() {
    return {
      showTooltip: false,
      tooltipContent: {
        title: '',
        subtitle: '',
        content: [],
      },
      tooltipPosition: {},
    };
  },
  components: {
    Tooltip,
    PieChart,
    ChartWrapper,
  },
  computed: {
    ...mapState({
      storedStartDate: state => state.dashboard.reportRequest.startDate,
      storedEndDate: state => state.dashboard.reportRequest.endDate,
    }),
    tooltipTitle() {
      const fromDate = timeFormat('%b %d, %Y')(this.storedStartDate);
      const toDate = timeFormat('%b %d, %Y')(this.storedEndDate);

      return fromDate + ' - ' + toDate;
    },
  },
  methods: {
    setTooltip(val) {
      this.tooltipPosition = val.position;
      this.updateTooltipContent(val.data);
      this.showTooltip = true;
    },
    updateTooltipContent(data) {
      this.tooltipContent.title = this.tooltipTitle;
      this.tooltipContent.subtitle = data.label;
      this.tooltipContent.content = [getValueAndLabel(data.displayValue, data.metric)];
    },
    hideTooltip() {
      this.showTooltip = false;
    },
  },
};
</script>

<style>
.pie-donut-chart {
  width: 100%;
}
</style>
